import usePermissionsStore from '@/stores/usePermissionsStore'
import { IPermissionProps } from '@/types/shared'
import { Alert } from 'vnetwork-ui'

interface Options {
    rsname?: string
    // Alternative resources: granted if ANY satisfies require_scopes (OR).
    rsnames?: string[]
    require_scopes: string[]
    visible_permission_denied: boolean
    useInSidebar?: boolean
}

export interface IProps {
    scopes?: string[]
}

const withPermission = (
    Component: ({}: IPermissionProps) => React.ReactNode,
    {
        require_scopes,
        rsname,
        rsnames,
        visible_permission_denied,
        useInSidebar = false,
    }: Options
) => {
    return ({}: IPermissionProps) => {
        const { permissions, isAdmin } = usePermissionsStore()

        const searchPermisstionByResource = (rsname: string) => {
            return (
                permissions.find(
                    (permission) => permission?.rsname === rsname
                ) || null
            )
        }

        // trước đó dùng hoc cho toàn bộ các component nhưng thấy khó quản lý nên chỉ dùng cho sidebar useInSidebar = true mới check cong hog thì thôi, cơ bản nếu vô path đó mà hog có quyền thì backend cũng 403
        const isGranted = (scopes: string[]) => {
            return useInSidebar
                ? require_scopes?.every((rq_scope) => scopes.includes(rq_scope))
                : true
        }

        // Resolve the resource whose scopes we surface: prefer any rsnames alternative
        // that satisfies require_scopes (OR), else fall back to the single rsname.
        const candidateResources =
            rsnames && rsnames.length > 0 ? rsnames : [rsname!]
        const grantingScopes =
            candidateResources
                .map((res) => searchPermisstionByResource(res)?.scopes || [])
                .find((scopes) => isGranted(scopes)) || []
        const scopes = grantingScopes

        if (isGranted(scopes) || isAdmin) {
            return <Component scopes={scopes} />
        }

        if (!visible_permission_denied) {
            return null
        }

        return (
            <Alert
                size="small"
                variant="error"
                className="whitespace-nowrap flex-shrink-0"
            >
                {`Required resource ${rsname} and scopes [${require_scopes}] to use`}
            </Alert>
        )
    }
}

export default withPermission
